import React, { useEffect } from 'react'
import { SiteHeader } from '../components/site-header'
import { ContactHero } from '../components/contact/hero-section'
import { ContactInfo } from '../components/contact/contact-info'
import { METADATA } from '../components/meta/metadata'
import { TestimonialsSection } from '../components/shared/testimonials-section'

export default function ContactPage() {
  // Set metadata for the page
  useEffect(() => {
    document.title = METADATA.contact.title;
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', METADATA.contact.description);
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <ContactHero />
        <ContactInfo />
        <TestimonialsSection className="bg-primary/5" />
        <div className="h-[120px]"></div>
      </main>
    </div>
  );
}